import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Connector, IConnector} from '../../shared/model/connector.model';
import {ConnectorService} from './connector.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Customer} from '../../shared/model/customer.model';
import {Organization} from '../../shared/model/organization.model';


@Component({
  selector: 'app-connector-update',
  templateUrl: './connector-update.component.html'
})
export class ConnectorUpdateComponent implements OnInit {
  connector: IConnector = new Connector();
  isSaving: boolean;
  @Input() connectorEdit;
  @Input() customerId;

  constructor(protected connectorService: ConnectorService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.isSaving = false;
// alert(' in init ==' + this.connectorEdit);
    if (this.connectorEdit) {
      this.connectorService.find(this.connectorEdit).subscribe(
        (res: HttpResponse<IConnector>) => {
          this.connector = res.body;
          // alert(this.connector);
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }

    // this.activatedRoute.data.subscribe(({connector}) => {
    //   this.connector = connector;
    // });
  }


  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  save() {
    this.isSaving = true;
    // this.connector.organization = new Organization(1);

    if (this.connector.id !== undefined) {
      this.subscribeToSaveResponse(this.connectorService.update(this.connector));
    } else {

      this.subscribeToSaveResponse(this.connectorService.create(this.connector));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IConnector>>) {
    result.subscribe((res: HttpResponse<IConnector>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss('cancel');

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
